import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { useAuth } from "@/context/AuthContext";

export const ETAT = {
  valide: ["Valide", "bg-emerald-100 text-emerald-700"],
  bientot: ["Expire bientôt", "bg-amber-100 text-amber-700"],
  expiree: ["Expiré", "bg-red-100 text-red-700"],
};

export const EtatBadge = ({ statut, jours, testid }) => {
  if (!statut) return <span className="text-xs text-muted-foreground">—</span>;
  const [l, c] = ETAT[statut];
  return <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${c}`} data-testid={testid}>{l}{statut !== "expiree" ? ` · ${jours} j` : ""}</span>;
};

export const SEL = "h-9 w-full rounded-md border bg-background px-2 text-sm";

export function useEmployes(annee) {
  const { societeId } = useApp();
  const { role } = useAuth();
  const [items, setItems] = useState(null);
  const q = new URLSearchParams({ societe_id: societeId || "all", ...(annee && { annee }) }).toString();
  const load = () => api.get(`/employes?${q}`).then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, [q]); // eslint-disable-line
  return { items, load, editable: role === "administrateur" || role === "comptabilite", q };
}

export async function uploadFile(file) {
  if (!file) return {};
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/files/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return { file_id: data.id, file_nom: data.filename };
}
